import { Button } from '@/components/ui/button'
import { Icon } from '@/components/ds/Icon'
import { AvatarIniciales } from '@/components/ds'
import { OnboardingSetupScreen } from '@/pages/onboarding/OnboardingSetupScreen'
import { useSetupStatus } from '@/hooks/useSetupStatus'
import { useUser } from '@/contexts/UserContext'

// Wrapper mínimo: la configuración de onboarding es una pantalla única
// (OnboardingSetupScreen). No hay pasos, progreso por etapas ni botón "Saltar
// por ahora" en ningún estado — el gate (`wizard_pending`) sólo se libera
// completando el formulario combinado de empresa + cargo del owner.
//
// TODO test (loading inicial): muestra spinner mientras isLoading=true del useSetupStatus
// TODO test (error setup-status): muestra mensaje de error + botón de retry si setup-status falla
// TODO test: renderiza OnboardingSetupScreen cuando el setup-status cargó sin error
// TODO test: la topbar no tiene navegación (ningún enlace fuera de esta pantalla)

/**
 * Barra superior de la pantalla. Deliberadamente SIN navegación: acá el usuario
 * no puede irse a otra parte, así que sólo lleva la marca y quién está sesión.
 */
function TopbarOnboarding() {
  const { user } = useUser()

  return (
    <div className="flex h-14 flex-none items-center gap-2.5 border-b bg-background px-[22px]">
      <span className="flex size-[26px] flex-none items-center justify-center rounded-md bg-primary text-primary-foreground">
        <Icon name="shield" size={17} />
      </span>
      <span className="text-sm font-semibold tracking-[-0.01em]">Fácil Control</span>
      <span className="flex-1" />
      {user && (
        <>
          <span className="truncate text-[12.5px] text-meta">{user.email}</span>
          <AvatarIniciales iniciales={user.iniciales} />
        </>
      )}
    </div>
  )
}

export function OnboardingWizard() {
  const { status, isLoading: isLoadingStatus, error: errorStatus, invalidate } = useSetupStatus()

  const isInitialLoading = isLoadingStatus && !status

  if (isInitialLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-canvas">
        <div className="size-8 animate-fc-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    )
  }

  if (errorStatus) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-canvas">
        <div className="max-w-sm space-y-4 px-4 text-center">
          <p className="text-[13px] text-destructive">
            No se pudo cargar el estado de configuración. Verifica tu conexión.
          </p>
          <Button variant="outline" onClick={invalidate}>
            Reintentar
          </Button>
        </div>
      </div>
    )
  }

  return (
    <div className="flex min-h-screen flex-col bg-canvas">
      <TopbarOnboarding />
      <main className="flex-1">
        <OnboardingSetupScreen onInvalidateSetupStatus={invalidate} />
      </main>
    </div>
  )
}
